import { FeatureFlagsGrid } from './FeatureFlagsGrid';

export const FeatureFlagsPlaceholderRows = () => {
  const rows = [1, 2, 3, 4];

  return rows.map((rowNum) => (
    <div key={rowNum} className="p-4 border-b border-gray-300 animate-pulse">
      <FeatureFlagsGrid
        customProperties={<div className="w-full h-10 bg-light-grey rounded" />}
        description={<div className="w-3/4 h-4 bg-light-grey rounded" />}
        isEnabled={<div className="w-4 h-4 bg-light-grey rounded" />}
        isEnabledAdmin={<div className="w-4 h-4 bg-light-grey rounded" />}
        isEnabledDev={<div className="w-4 h-4 bg-light-grey rounded" />}
        name={<div className="w-2/3 h-4 bg-light-grey rounded" />}
      />
    </div>
  ));
};
